<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col class="mt-12" cols="12" sm="10" md="8" lg="6" xl="4">
        <h1 class="text-h4 font-weight-bold">Terms &amp; Conditions</h1>
        <div class="mt-12">
          <div class="mb-12">
            <h2 class="text-h6 mb-2">Description of service</h2>
            <p>
              100ASA, Inc. (“100ASA”, “we”, “us” or “our”) provides a platform
              via its website, and apps (the “Site”) to a community of
              registered users (“users” or “you”) to engage in a variety of
              activities, including to upload and display photographs (“Visual
              Content”) share comments, opinions and ideas, promote Visual
              Content collections, register for premium membership accounts
              (“Premium Accounts”), and participate to photo exhibition
              galleries. The foregoing list of Services is not all-inclusive and
              additional Services may be offered by us from time to time. The
              following are the terms of use (“Terms”) for using the Site and
              the Services.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Acceptance of Terms</h2>
            <p>
              By using the services, you are agreeing, on behalf of yourself and
              those you represent, to comply with and be legally bound by these
              terms as well as our privacy policy and all applicable laws. If
              you, for yourself or on behalf of those you represent, do not
              agree to any provision of these terms, you must, for yourself and
              on behalf any such person(s), discontinue the registration
              process, discontinue your use of the services, and, if you are
              already registered, cancel your account.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Modification of Terms</h2>
            <p>
              100ASA reserves the right, at its sole discretion, to modify or
              replace the Terms at any time. If the alterations constitute a
              material change to the Terms, 100ASA will notify you by posting an
              announcement on the Site. What constitutes a material change will
              be determined at 100ASA's sole discretion. You are responsible for
              reviewing and becoming familiar with any such modifications. Using
              any Service or viewing any Visual Content constitutes your
              acceptance of the Terms as modified.
            </p>
            <p>
              In addition, when using particular features of the Services, you
              are subject to any posted guidelines, terms or rules applicable to
              such Services.
            </p>
            <p>
              Your access to and use of the Site and our Services may be
              interrupted from time to time as a result of equipment
              malfunction, updating, maintenance or repair of the Site or any
              other reason within or outside of our control. 100ASA reserves the
              right to suspend or discontinue the availability of the Site, any
              Service and to remove any Visual Content at any time at its sole
              discretion and without prior notice. 100ASA may also impose limits
              on certain features and Services or restrict your access to parts
              of or all of the Site and the Services without notice or
              liability. The Site should not be used or relied upon for storage
              of your Visual Content and you are directed to retain your own
              copies of all Visual Content posted on the Site.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Registration</h2>
            <p>
              As a condition to using Services, you are required to open an
              account with 100ASA and select a password and username, and to
              provide registration information. The registration information you
              provide must be accurate, complete, and current at all times.
              Failure to do so constitutes a breach of the Terms, which may
              result in immediate termination of your access to the Services, by
              either terminating your email access or your account. Any personal
              information that you provide to 100ASA is governed by the 100ASA
              <nuxt-link to="/privacy-policy">Privacy Policy.</nuxt-link>
            </p>
            <p>
              You may not use as a username the name of another person or entity
              or that is not lawfully available for use, a name or trademark
              that is subject to any rights of another person or entity other
              than you without appropriate authorization, or a name that is
              otherwise offensive, vulgar or obscene.
            </p>
            <p>
              You are responsible for maintaining the confidentiality of your
              password and are solely responsible for all activities resulting
              from the use of your password and conducted through your 100ASA
              account.
            </p>
            <p>
              Services are available to authorized representatives of legal
              entities and to individuals who are either (i) at least 18 years
              old to register for Premium Accounts or license Visual Content
              through 100ASA, or (ii) at least 14 years old, and who are
              authorized to access the Site by a parent or legal guardian. If
              you have authorized a minor to use the Site, you are responsible
              for the online conduct of such minor, and the consequences of any
              misuse of the Site by the minor. Parents and legal guardians are
              warned that the Site does display Visual Content containing nudity
              and violence that may be offensive to some.
            </p>
            <p>
              The Services are for use by a) individuals who own Visual Content;
              b) entities that represent owners of Visual Content including but
              not limited to galleries, agents, representatives, distributors
              other market intermediaries; and c) individuals and entities
              seeking to license Visual Content. We are currently not accepting
              illustration and graphic design content to upload on the Site. If
              you are the owner of the Visual Content, but not the creator, you
              are not allowed to upload content for the purposes of
              self-advertising.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">User conduct</h2>
            <p>
              All Visual Content posted or otherwise submitted to the Site, and
              any comments, or other communications (“Communications”, with
              Visual Content and Communications collectively referred to as
              “Content”) is the sole responsibility of the account holder from
              which such Communications originate and you acknowledge and agree
              that you, and not 100ASA, are entirely responsible for all Content
              that you post, or otherwise submit to the Site, including via
              messages exchanged through 100ASA's comment reply service. 100ASA
              does not control user submitted Content and, as such, does not
              guarantee the accuracy, integrity or quality of such Content. You
              understand that by using the Site you may be exposed to Content
              that is offensive, indecent or objectionable.
            </p>
            <p>
              As a condition of use, you promise not to use the Services for any
              purpose that is unlawful or prohibited by these Terms, or any
              other purpose not reasonably intended by 100ASA. By way of
              example, and not as a limitation, you agree not to use the
              Services:
            </p>
            <ol>
              <li>
                To abuse, harass, threaten, impersonate or intimidate any
                person;
              </li>
              <li>
                To post or transmit, or cause to be posted or transmitted, any
                Content that is libelous, defamatory, obscene, pornographic,
                abusive, offensive, profane, or that infringes any copyright or
                other right of any person;
              </li>
              <li>
                To communicate with 100ASA representatives or other users in an
                abusive or offensive manner;
              </li>
              <li>
                For any purpose (including posting or viewing Content) that is
                not permitted under the laws of the jurisdiction where you use
                the Services;
              </li>
              <li>
                To post or transmit, or cause to be posted or transmitted, any
                Communication designed or intended to obtain password, account,
                or private information from any 100ASA user;
              </li>
              <li>
                To create or transmit unwanted 'spam' to any person or any URL;
              </li>
              <li>
                To create multiple accounts for the purpose of voting for or
                against users' Visual Content;
              </li>
              <li>
                To post copyrighted Content that does not belong to you, unless
                you post such Content subject to providing appropriate
                attribution to the copyright owner and a link to the source of
                the Content;
              </li>
              <li>
                With the exception of accessing RSS feeds, you agree not to use
                any robot, spider, scraper or other automated means to access
                the Site for any purpose without our express written permission.
                Additionally, you agree that you will not: (i) take any action
                that imposes, or may impose in our sole discretion an
                unreasonable or disproportionately large load on our
                infrastructure; (ii) interfere or attempt to interfere with the
                proper working of the Site or any activities conducted on the
                Site; or (iii) bypass any measures we may use to prevent or
                restrict access to the Site;
              </li>
              <li>
                To artificially inﬂate or alter vote counts, comments, or any
                other Service or for the purpose of giving or receiving money or
                other compensation in exchange for votes and/or in an attempt to
                alter the result of any contest or promotion, or for
                participating in any other organized effort that in any way
                artificially alters the results of Services;
              </li>
              <li>
                To advertise to, or solicit, any user to buy or sell any third
                party products or services, or to use any information obtained
                from the Services in order to contact, advertise to, solicit, or
                sell to any user without their prior explicit consent;
              </li>
              <li>
                To promote or sell Visual Content of another person unless you
                are expressly authorized to do so; or
              </li>
              <li>To sell, assign or otherwise transfer your profile.</li>
            </ol>
            <p>
              To report a suspected abuse of the Site or a breach of the Terms
              (other than relating to copyright infringement which is addressed
              under “COPYRIGHT COMPLAINTS” below) please send written notice to
              100ASA at email:&nbsp;<a href="mailto:info@100asa.com"
                >info@100asa.com</a
              >.
            </p>
            <p>
              You are solely responsible for your interactions with other users
              of the Site, including any communications that you exchange
              through 100ASA's photo discussion service. 100ASA reserves the
              right, but has no obligation, to review disputes between you and
              other users. This includes the right to review messages exchanged
              through 100ASA's messenger service, based on any reports that
              100ASA receives alleging the violation of these Terms through the
              use of 100ASA's messenger service, including without limitation,
              reports regarding alleged harassment, indecency, and offensive
              messages.
            </p>
            <p>
              If the Services or Site are used in a manner that violates the
              Terms in any way, 100ASA may at its sole discretion, but is not
              required to, suspend or terminate your account, disable your
              access to the Site and/or take any steps that it deems appropriate
              to address the situation.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">
              Visual content submitted or made available for inclusion on the
              service
            </h2>
            <p>
              Please read this section carefully before posting, uploading, or
              otherwise submitting any Content to the site. In consideration of
              100ASA agreement to allow you to post Content to the Site and
              100ASA's agreement to publish such Content and for other valuable
              consideration the receipt and sufficiency of which are hereby
              expressly and irrevocably acknowledged, you agree with 100ASA as
              follows:
            </p>
            <ol>
              <li>
                You acknowledge that:
                <ul>
                  <li>
                    By uploading your photographic or graphic works to 100ASA
                    you retain full rights to those works that you had prior to
                    uploading.
                  </li>
                  <li>
                    The license granted to 100ASA includes the right to use your
                    Content fully or partially for promotional and commercial
                    reasons (i.e. photo books, magazines, prints) and to
                    distribute and redistribute your Content to other parties,
                    web-sites, applications, and other entities, provided such
                    Content is attributed to you in accordance with the credits
                    (i.e. username, profile picture, photo title, descriptions,
                    tags, and other accompanying information) if any and as
                    appropriate, all as submitted to 100ASA by youu;
                  </li>
                  <li>
                    100ASA uses industry recognized software and measures to
                    restrict the ability of users and visitors to the Site to
                    make high resolution copies of Content posted on the Site.
                    Notwithstanding this, 100ASA makes no representation and
                    warranty that Content posted on the Site will not be
                    unlawfully copied without your consent. 100ASA does not
                    restrict the ability of users and visitors to the Site to
                    make low resolution or 'thumbnail' copies of Content posted
                    on the Site and you hereby expressly authorize 100ASA to
                    permit users and visitors to the Site to make such low
                    resolution copies of your Content; and
                  </li>
                  <li>
                    Subject to the terms of the foregoing license, you retain
                    full ownership or other rights in your Content and any
                    intellectual property rights or other proprietary rights
                    associated with your Content.
                  </li>
                </ul>
              </li>
              <li>
                You represent and warrant that:
                <ul>
                  <li>
                    You are the owner of all rights, including all copy rights
                    in and to all Content you submit to the site;
                  </li>
                  <li>
                    You have the full and complete right to enter into this
                    agreement and to grant to 100ASA the rights in the Content
                    herein granted, and that no further permissions are required
                    from, nor payments required to be made to any other person
                    in connection with the use by 100ASA of the Content as
                    contemplated herein; and
                  </li>
                  <li>
                    The Content does not defame any person and does not infringe
                    upon the copyright, moral rights, publicity rights, privacy
                    rights or any other right of any person, or violate any law
                    or judicial or governmental order.
                  </li>
                </ul>
              </li>
              <li>
                You shall not have any right to terminate the permissions
                granted herein, nor to seek, obtain, or enforce any injunctive
                or other equitable relief against 100ASA all of which such
                rights are hereby expressly and irrevocably waived by you in
                favour of 100ASA.
              </li>
            </ol>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Fair storage policy</h2>
            <p>
              100ASA maintains a fair storage policy to ensure stable and fast
              service to all users. The storage limits set forth in the Terms
              may be changed from time to time without notice and you are
              responsible for complying with such changes.
            </p>
            <p>
              Accounts are limited to a maximum number or photos depending on
              their role - max 10GB for each user (for more info about photo
              upload allowance please refer to
              <nuxt-link to="/reputation">Reputation</nuxt-link>
              ). Any additional storage may result in restrictions on your
              account including limited access to your Visual Content or a
              requirement to upgrade if the limit is exceeded for several
              months.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Links</h2>
            <p>
              The Services may provide, or third parties may provide, links to
              other sites or resources. Because 100ASA has no control over such
              sites and resources, you acknowledge and agree that 100ASA is not
              responsible for the availability of such external sites or
              resources, and does not endorse and is not responsible or liable
              for any content, advertising, products or other materials on or
              available from such sites or resources. You further acknowledge
              and agree that 100ASA shall not be responsible or liable, directly
              or indirectly, for any damage or loss caused or alleged to be
              caused by or in connection with use of or reliance on any such
              content, goods or services available on or through any such site
              or resource.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Release and indemnity</h2>
            <p>
              You hereby expressly and irrevocably release and forever discharge
              100ASA, its affiliated and associated companies and its authorized
              distributors, and their respective directors, officers, employees,
              agents, representatives, independent and dependent contractors,
              licensees, successors and assigns of and from any and all actions,
              causes of action, suits, proceedings, liability, debts, judgments,
              claims and demands whatsoever in law or equity which you ever had,
              now have, or hereafter can, shall or may have, for or by reason
              of, or arising directly or indirectly out of your use of the Site
              and the Services.
            </p>
            <p>
              You hereby agree to indemnify and hold harmless 100ASA, its
              affiliated and associated companies and its authorized
              distributors, and their respective directors, officers, employees,
              agents, representatives, independent and dependent contractors,
              licensees, successors and assigns from and against all claims,
              losses, expenses, damages and costs (including, but not limited
              to, direct, incidental, consequential, exemplary and indirect
              damages), and reasonable attorneys' fees, resulting from or
              arising out of (i) a breach of these Terms, (ii) Content posted on
              the Site, (iii) the use of the Services or Premium Accounts, by
              you or any person using your account or 100ASA Username and
              password, (iv) the licensing or use of your Visual Content, or (v)
              any violation of any rights of a third party. 100ASA reserves the
              right, at its own expense, to assume the exclusive defense and
              control of any matter otherwise subject to indemnification by you.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Trademarks</h2>
            <p>
              100ASA, 100asa.com and other 100ASA graphics, logos, designs, page
              headers, button icons, scripts, and service names are registered
              trademarks, trademarks or trade dress of 100ASA. 100ASA's
              trademarks and trade dress may not be used in connection with any
              product or service without the prior written consent of 100ASA.
              The images and icons available in the 100ASA icon pack may be used
              by partners and third party sites in connection with providing
              appropriate links to the 100ASA Site so long as they are used in a
              manner that is consistent with 100ASA's requirements.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Termination</h2>
            <p>
              100ASA may terminate or suspend any and all Services and/or your
              100ASA account immediately, without prior notice or liability, for
              any reason whatsoever, including without limitation if you breach
              the Terms. Upon termination of your account, your right to use the
              Services will immediately cease. If you wish to terminate your
              100ASA account, you may simply discontinue using the Services
              (subject to termination provisions specific to Premium Accounts).
              All provisions of the Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership and rights provisions and warranties,
              warranty disclaimers, indemnity and limitations of liability.
            </p>
            <p>
              It is your responsibility to remove all Visual Content from your
              account and/or Premium Account prior to termination. Upon
              termination of your account, 100ASA will automatically remove all
              Visual Content posted to your account.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Warranty disclaimer</h2>
            <p>
              You use the site and the services at your own risk. The site and
              the services are provided on an “as is, as available” basis.
              100ASA expressly disclaims all warranties, including the
              warranties of merchantability, title, fitness for a particular
              purpose and non-infringement. 100ASA disclaims all responsibility
              for any loss, injury, claim, liability, or damage of any kind
              resulting from, arising out of or in any way related to (a) any
              errors in or omissions from this site and the services, including,
              but not limited to, technical inaccuracies and typographical
              errors, (b) third party communications, (c) any third party
              websites or content directly or indirectly accessed through links
              in the site, including but not limited to any errors or omissions,
              (d) the unavailability of all or any part of the site or the
              services, (e) your use of the site or the services, or (f) your
              use of any equipment or software in connection with the site or
              the services.
            </p>
          </div>

          <div class="mb-12">
            <h2 class="text-h6 mb-2">Limitation of liability</h2>
            <p>
              Except as otherwise provided by law, neither 100ASA nor any of its
              affiliates, parents, subsidiaries, authorized distributors,
              directors, shareholders, employees or agents shall be liable for
              any loss, injury, claim, liability, or damage of any kind
              resulting from your use of the site, any facts or opinions
              appearing thereon, or the services. 100ASA shall not be liable for
              any special, direct, indirect, incidental, punitive or
              consequential damages of any kind whatsoever (including, without
              limitation, attorneys' fees) in any way due to, resulting from, or
              arising in connection with the use of or inability to use the site
              or services. To the extent the foregoing limitation of liability
              is prohibited or fails of its essential purpose, 100ASA's sole
              obligation to you for damages shall be limited to us$100.00.
            </p>
            <p>
              You and 100ASA agree that any proceedings to resolve or litigate
              any dispute arising hereunder will be conducted solely on an
              individual basis, and that you will not seek to have any dispute
              heard as a class action, a representative action, a collective
              action, a private attorney-general action, or in any proceeding in
              which you act or propose to act in a representative capacity. You
              further agree that no proceeding will be joined, consolidated, or
              combined with another proceeding without the prior written consent
              of 100ASA and all parties to any such proceeding.
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  head({ $seo }) {
    return $seo({
      title: 'Terms & Conditions',
      description: 'If you become a 100ASA member, these Terms & Conditions will apply. User conduct. Fair storage policy.',
      robots: 'none'
    })
  }
}
</script>
